import React from 'react';
export function useOnFocusOutside(onFocusOutside) {
  var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var capturedRef = React.useRef(false);
  React.useEffect(function () {
    if (enable) {
      var handleFocus = function handleFocus() {
        capturedRef.current = false;
        window.setTimeout(function () {
          if (!capturedRef.current) {
            onFocusOutside();
          }
        }, 0);
      };

      window.addEventListener('focus', handleFocus, {
        capture: true
      });
      return function () {
        window.removeEventListener('focus', handleFocus, {
          capture: true
        });
      };
    }

    return undefined;
  }, [enable, onFocusOutside]);
  return React.useCallback(function () {
    capturedRef.current = true;
  }, []);
}
// #sourceMappingURL=useOnFocusOutside.js.map